// Spanish translations for src/config/tutorials.md.
// See tutorials.fr.ts for the schema; missing entries fall back to English.
export const tutorialsEs: Record<string, string> = {
  'first-game.0':
    "Esta es la arena de combate. Tu personaje es la silueta fantasmal en el centro, que se mueve por el mapa — busca y ataca enemigos automáticamente.",

  'first-game.1':
    "Esta es tu barra de vida. Cuando se vacía, mueres. Pero la muerte no es el final…",

  'first-game.2':
    "Esta es tu barra de maná. Algunas acciones cuestan maná; se regenera continuamente por sí sola.",

  'first-game.3':
    "Cada estadística tiene su propia barra de experiencia y nivel. Infligir y recibir daño o gastar maná llena estas barras — un nivel más alto significa reservas de vida y maná más fuertes. El nivel más alto alcanzado también te da un bono al ganar experiencia para esa barra.",

  'first-game.4':
    "Pulsa el botón de configuración de combate para elegir y cambiar tu acción activa.",

  'first-game.5':
    "Esta es la configuración de combate. La primera ranura es tu ataque automático — puedes cambiar tu acción en cualquier momento, elige la que mejor te convenga. Más adelante desbloquearás más ranuras de disparador que te permitirán usar varias acciones juntas para sinergias devastadoras.",

  'first-death.0':
    "Has muerto. La experiencia de maestría ganada en esta vida se conserva a través de tus renaceres — tras el renacer podrás gastar los puntos de maestría desbloqueados para grandes mejoras de poder.",

  'first-rebirth.0':
    "Abre el panel de Maestrías para gastar los puntos de maestría que hayas ganado en esta partida.",

  'first-rebirth.1':
    "Las maestrías son árboles pasivos permanentes que persisten a través de cada Renacer. Aquí también puedes ver lo cerca que estás de un nuevo punto y cuánta experiencia y cuántos puntos obtendrías si decides renacer durante la partida (usa el botón de la calavera arriba a la izquierda para morir). Haz clic en una maestría para abrir su árbol y gastar puntos en bonos permanentes.",

  'first-boss.0':
    "Ha aparecido un jefe. Los jefes son mucho más duros que los enemigos normales — prepárate para una pelea larga. Matar jefes puede desbloquear contenido nuevo.",

  'first-ascent.0':
    "¡Tu primera Ascensión está completa! Cada acción, maestría y estadística se reinicia. Pulsa el botón de Ascensión para ver tu Punto de Universo — un bono permanente que se mantendrá en todas las partidas futuras.",

  'second-trigger.0':
    "¡Has desbloqueado una segunda ranura de disparador de acción! Abre la configuración de combate para configurarla.",

  'second-trigger.1':
    "Pulsa tu nueva ranura para elegir cómo se dispara — Tiempo, Golpe crítico o Aflicción. Aplica una penalización global de daño de ×0,75, pero una segunda acción bien combinada compensa con creces.",

  'first-rune.0':
    "¡Has ganado una ranura de runa! Abre tu configuración de combate para asignar runas que mejoren tu acción.",

  'first-rune.1':
    "Pulsa el botón de runa junto a tu acción para escoger runas de tu reserva desbloqueada. También puedes pre-asignar runas para ahorrar tiempo. Se usarán automáticamente cuando se desbloqueen en esta partida y en el futuro.",

  'first-enemy-level.0':
    "¡Has desbloqueado un nivel de enemigo superior! Pulsa el botón de nivel de enemigo para abrir los controles.",

  'first-enemy-level.1':
    "Usa las flechas para elegir el nivel de enemigo, o activa Auto para que suba automáticamente a medida que desbloqueas nuevos niveles. Niveles más altos significan enemigos más duros — y más XP por combate.",
}
